import Vue from "vue";
import Vuex from "vuex";
import router from "./router.js";
import firebase from "firebase/compat/app";
import db from "./firebase/init.js";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    userId: null,
    userRole: null,
    userCallCenterOnline: null,
    userCallCenterCompanies: null,
    userPermissions: null,
    userName: null,
    userFirstName: null,
    userLastName: null,
    userCompanies: null,
    userCompany: null,
    userCompanyName: null,
    userOperator: false,
    userBranches: null,
    userAbb: null,
    error: false,
    companyPrimaryColor: null,
    companySecondaryColor: null,
    companyPrimaryColorRGBA: null,
    companySecondaryColorRGBA: null,
    companyPackages: null,
    companyTrials: null,
    companyType: null,
    menuOpen: false,
    version: null,
    authenticated: false,
    demoMode: false,
  },

  mutations: {
    authUser(state, userData) {
      state.userName = userData.userName;
      state.userRole = userData.userRole;
      state.userPermissions = userData.userPermissions;
      state.userCompanies = userData.userCompanies;
      state.userCompany = userData.userCompany;
      state.userBranches = userData.userBranches;
      state.userId = userData.userId;
      state.userFirstName = userData.userFirstName;
      state.userLastName = userData.userLastName;
      state.userAbb = userData.userAbb;
      state.userOperator = userData.userOperator;
      state.userCallCenterOnline = userData.userCallCenterOnline;
      state.userCallCenterCompanies = userData.userCallCenterCompanies;
    },
    authUserAuth(state, userData) {
      state.authenticated = userData.authenticated;
    },
    authUserError(state, userData) {
      state.error = userData.error;
    },

    version(state, versionData) {
      state.version = versionData.version;
    },

    companySettings(state, userData) {
      state.userCompanyName = userData.userCompanyName;
      state.companyPrimaryColor = userData.companyPrimaryColor;
      state.companySecondaryColor = userData.companySecondaryColor;
      state.companyPrimaryColorRGBA = userData.companyPrimaryColorRGBA;
      state.companySecondaryColorRGBA = userData.companySecondaryColorRGBA;
      state.companyPackages = userData.companyPackages;
      state.companyTrials = userData.companyTrials;
      state.companyType = userData.companyType;
    },

    menuOpen(state, menuData) {
      state.menuOpen = menuData.status;
    },
    demoMode(state, demoData) {
      state.demoMode = demoData.status;
    },

    onlineCallUserStatus(state, userData) {
      state.userCallCenterOnline = userData.status;
    },

    clearAuthData(state) {
      state.userName = null;
      state.authenticated = false;
      state.userRole = null;
      state.userPermissions = null;
      state.userCompanies = null;
      state.userCompany = null;
      state.userCompanyName = null;
      state.userId = null;
      state.userFirstName = null;
      state.userLastName = null;
      state.userAbb = null;
      state.userPrimaryColor = null;
      state.userSecondaryColor = null;
      state.error = false;
      state.userCallCenterOnline = null;
      state.userCallCenterCompanies = null;
      state.userOperator = false;
    },
  },

  actions: {
    async getIP() {
      // Get IP info
      let data = "";
      await axios
        .get(
          `https://pro.ip-api.com/json/?key=M08tSvdEklYEPub&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,mobile,proxy,hosting,query`,
        )
        .then((response) => {
          data = response.data;
        });
      return data;
    },

    userLogout({ commit }) {
      router.replace("/login");
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("clearAuthData");
        });
    },

    tryAutoLogin({ commit, dispatch, state }, user) {
      if (state.userId == null) {
        let userId = null;
        let userName = null;
        let userFirstName = null;
        let userLastName = null;
        let userRole = null;
        let userCompanies = null;
        let userCompany = null;
        let userCompanyName = null;
        let userBranches = null;
        let userAbb = null;
        let userPermissions = null;
        let userCallCenterOnline = false;
        let userCallCenterCompanies = null;
        let userOperator = false;

        return db
          .collection("users")
          .where("user_id", "==", user.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              userId = doc.data().user_id;
              userName = doc.id;
              userFirstName = doc.data().firstName;
              userLastName = doc.data().lastName;
              userRole = doc.data().userRole;
              if (doc.data().callActive && doc.data().callActive == true) {
                userCallCenterOnline = true;
              }
              if (doc.data().callCompanies) {
                userCallCenterCompanies = doc.data().callCompanies;
              }
              userPermissions = doc.data().userPermissions;
              if (
                doc.data().userRole == "employee" ||
                doc.data().userRole == "manager"
              ) {
                userBranches = doc.data().branches;
              } else {
                userBranches = null;
              }
              if (doc.data().operator) {
                userOperator = doc.data().operator;
              }
              userOperator;
              userCompanies = doc.data().accessCompanies;
              userCompany = doc.data().company;
              userAbb =
                doc.data().firstName.charAt(0) + doc.data().lastName.charAt(0);
            });
          })
          .then(() => {
            let userPrimaryColor = null;
            let userSecondaryColor = null;
            db.collection("companies")
              .doc(userCompany)
              .get()
              .then((doc) => {
                commit("companySettings", {
                  userCompanyName: doc.data().name,
                  companyPrimaryColor: doc.data().colors.primary.hex,
                  companySecondaryColor: doc.data().colors.secondary.hex,
                  companyPrimaryColorRGBA: `rgba(${
                    doc.data().colors.primary.rgba.r
                  },${doc.data().colors.primary.rgba.g},${
                    doc.data().colors.primary.rgba.b
                  },`,

                  companySecondaryColorRGBA: `rgba(${
                    doc.data().colors.secondary.rgba.r
                  },${doc.data().colors.secondary.rgba.g},${
                    doc.data().colors.secondary.rgba.b
                  },`,

                  companyPackages: doc.data().packages,
                  companyTrials: doc.data().trials,
                  companyType: doc.data().type,
                });
              });
          })
          .then(() => {
            commit("authUser", {
              userId: userId,
              userName: userName,
              userFirstName: userFirstName,
              userLastName: userLastName,
              userRole: userRole,
              userPermissions: userPermissions,
              userCompanies: userCompanies,
              userCompany: userCompany,
              userCompanyName: userCompanyName,
              userBranches: userBranches,
              userAbb: userAbb,
              userCallCenterOnline: userCallCenterOnline,
              userCallCenterCompanies: userCallCenterCompanies,
              userOperator: userOperator,
            });
            commit("authUserAuth", {
              authenticated: true,
            });
          })
          .then(() => {
            // Laatste versie Pillarrr binnenladen
            let version = [];
            db.collection("news")
              .where("type", "==", "update")
              .where("published", "==", true)
              .orderBy("publishDate", "desc")
              .limit(51)
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  let pillarrrVersion = doc.data();
                  version.push(pillarrrVersion);
                });
              })
              .then(() => {
                commit("version", {
                  version: version[0].version,
                });
              });
          })
          .then(() => {
            // console.log("Klaar met updaten");
          });
      } else {
        // console.log("Updaten niet nodig");
      }
    },

    menuStatus({ commit }, status) {
      commit("menuOpen", {
        status: status,
      });
    },

    demoMode({ commit }, status) {
      commit("demoMode", {
        status: status,
      });
    },

    onlineCallStatus({ commit }, status) {
      commit("onlineCallUserStatus", {
        status: status,
      });
    },

    login({ commit, dispatch, state }, loginData) {
      if (loginData.remember == true) {
        // User wil be remebered in cache
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            firebase
              .auth()
              .signInWithEmailAndPassword(loginData.email, loginData.password)
              .then(() => {
                commit("authUserAuth", {
                  authenticated: true,
                });
                commit("authUserError", {
                  error: false,
                });

                if (loginData.destination) {
                  let path = "/" + loginData.destination;
                  // console.log("StorePath: ", path)
                  router.replace(path);
                } else {
                  router.replace("/home");
                }
              })
              .then(() => {
                let userFirstNameLogin = null;
                let userLastNameLogin = null;
                let userRoleLogin = null;
                let userCompanyLogin = null;

                firebase.auth().onAuthStateChanged((user) => {
                  if (user) {
                    db.collection("users")
                      .where("user_id", "==", user.uid)
                      .get()
                      .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                          userFirstNameLogin = doc.data().firstName;
                          userLastNameLogin = doc.data().lastName;
                          userRoleLogin = doc.data().userRole;
                          userCompanyLogin = doc.data().company;
                        });
                      })
                      .then(() => {
                        if (userRoleLogin == "superadmin") {
                          let selectedCompany = window.localStorage.getItem(
                            "selectedCompany",
                          );
                          if (!selectedCompany) {
                            window.localStorage.setItem(
                              "selectedCompany",
                              userCompanyLogin,
                            );
                          }
                        }
                      })
                      .then(() => {
                        db.collection("log").add({
                          time: new Date(),
                          logType: "info",
                          user: userFirstNameLogin + " " + userLastNameLogin,
                          userType: userRoleLogin,
                          company: userCompanyLogin,
                          actionType: "User Action",
                          action: "Login",
                          software: loginData.software,
                          browser: loginData.browser,
                          pillarrrVersion: loginData.pillarrrVersion,
                        });
                      });
                  }
                });
              })

              .catch((error) => {
                console.error("firebase Auth Sign-in error: ", error);
                commit("authUserError", {
                  error: true,
                });
                let logError = error;
                let logEmail = loginData.email;
                let logPassword = loginData.password;
                console.error("Login error: ", error);

                let clientIP = "";

                dispatch("getIP").then((data) => {
                  clientIP = data;

                  db.collection("log").add({
                    time: new Date(),
                    logType: "loginerror",
                    loginEmail: logEmail,
                    user: "",
                    userType: "",
                    company: "",
                    actionType: "User Action",
                    software: loginData.software,
                    browser: loginData.browser,
                    pillarrrVersion: loginData.pillarrrVersion,
                    action: "Error logging in : " + logEmail,
                    extra:
                      "<b>INLOGGEGEVENS</b> " +
                      "<br>" +
                      "<b>Email: </b> " +
                      logEmail +
                      "<br>" +
                      "<b>Password: </b> " +
                      logPassword +
                      "<br><br>" +
                      "<b>Location data: </b> " +
                      JSON.stringify(clientIP) +
                      "<br><br>" +
                      "<b>ERROR</b> " +
                      "<br>" +
                      JSON.stringify(error),
                  });
                });
              });
          })
          .catch((error) => {
            console.error("firebase Auth error: ", error);
          });
      } else {
        // User wil be remebered for one session
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.SESSION)
          .then(() => {
            return firebase
              .auth()
              .signInWithEmailAndPassword(loginData.email, loginData.password)
              .then(() => {
                commit("authUserAuth", {
                  authenticated: true,
                });
                commit("authUserError", {
                  error: false,
                });
                if (loginData.destination) {
                  let path = "/" + loginData.destination;
                  router.replace(path);
                } else {
                  router.replace("/home");
                }
              })
              .then(() => {
                let userFirstNameLogin = null;
                let userLastNameLogin = null;
                let userRoleLogin = null;
                let userCompanyLogin = null;

                firebase.auth().onAuthStateChanged((user) => {
                  if (user) {
                    db.collection("users")
                      .where("user_id", "==", user.uid)
                      .get()
                      .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                          userFirstNameLogin = doc.data().firstName;
                          userLastNameLogin = doc.data().lastName;
                          userRoleLogin = doc.data().userRole;
                          userCompanyLogin = doc.data().company;
                        });
                      })
                      .then(() => {
                        if (userRoleLogin == "superadmin") {
                          let selectedCompany = window.localStorage.getItem(
                            "selectedCompany",
                          );
                          if (!selectedCompany) {
                            window.localStorage.setItem(
                              "selectedCompany",
                              userCompanyLogin,
                            );
                          }
                        }
                      })
                      .then(() => {
                        db.collection("log").add({
                          time: new Date(),
                          logType: "info",
                          user: userFirstNameLogin + " " + userLastNameLogin,
                          userType: userRoleLogin,
                          company: userCompanyLogin,
                          actionType: "User Action",
                          action: "Login",
                          software: loginData.software,
                          browser: loginData.browser,
                          pillarrrVersion: loginData.pillarrrVersion,
                        });
                      });
                  }
                });
              })

              .catch((error) => {
                console.error("firebase Auth Sign-in error: ", error);
                commit("authUserError", {
                  error: true,
                });
                let logError = error;
                let logEmail = loginData.email;
                let logPassword = loginData.password;
                console.error("Login error: ", error);
                console.error("logError: ", logError);
                let clientIP = "";

                dispatch("getIP").then((data) => {
                  clientIP = data;

                  db.collection("log").add({
                    time: new Date(),
                    logType: "loginerror",
                    loginEmail: logEmail,
                    user: "",
                    userType: "",
                    company: "",
                    actionType: "User Action",
                    software: loginData.software,
                    browser: loginData.browser,
                    pillarrrVersion: loginData.pillarrrVersion,
                    action: "Error logging in : " + logEmail,
                    extra:
                      "<b>INLOGGEGEVENS</b> " +
                      "<br>" +
                      "<b>Email: </b> " +
                      logEmail +
                      "<br>" +
                      "<b>Password: </b> " +
                      logPassword +
                      "<br><br>" +
                      "<b>Location data: </b> " +
                      JSON.stringify(clientIP) +
                      "<br><br>" +
                      "<b>ERROR</b> " +
                      "<br>" +
                      JSON.stringify(error),
                  });
                });
              });
          })
          .catch((error) => {
            console.error("firebase Auth error: ", error);
          });
      }
    },
  },
});
